import { getObjectUtil } from 'packages/src'

export function getNameModelUtil (instance) {
  return (
    getObjectUtil(instance, 'name')
  ) || ''
}
